import { z } from 'zod';

import pgIntervalSchema from 'validationSchemas/pgInterval';

export const FormSchema = z.object({
  min_time_to_complete: pgIntervalSchema.nullable(),
  max_time_to_complete: pgIntervalSchema.nullable(),
  allow_self_service_extensions: z.boolean(),
  standard_extension_time: pgIntervalSchema.nullable(),
  standard_extension_fee: z.number().nullable(),
  max_extensions: z.number().nonnegative(),
  max_time_to_request_extension: pgIntervalSchema.nullable(),
  absences_allowed_before_fee: z.number().nonnegative().nullable(),
  absence_fee: z.number().nonnegative().nullable(),
  absence_fee_due: pgIntervalSchema.nullable(),
  absence_fee_due_lock: z.boolean(),
  no_permits_allowed_before_fee: z.number().nonnegative().nullable(),
  no_permit_fee: z.number().nonnegative().nullable(),
  no_permit_fee_due: pgIntervalSchema.nullable(),
  no_permit_fee_due_lock: z.boolean(),
  allow_cancellations: z.boolean(),
  cancellations_allowed_before_fee: z.number().nonnegative().nullable(),
  cancellation_fee: z.number().nonnegative().nullable(),
  cancellation_fee_due: pgIntervalSchema.nullable(),
  cancellation_fee_due_lock: z.boolean(),
  late_cancellations_allowed_before_fee: z.number().nonnegative().nullable(),
  late_cancellation_fee: z.number().nonnegative().nullable(),
  late_cancellation_fee_due: pgIntervalSchema.nullable(),
  late_cancellation_fee_due_lock: z.boolean(),
  late_cancellation_deadline: pgIntervalSchema.nullable(),
  issue_completion_certificate: z.boolean(),
});

export type FormInputValues = z.input<typeof FormSchema>;
export type FormOutputValues = z.output<typeof FormSchema>;
